import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { fetchServer } from "../Base/modelManager";

class BadgeEditor extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            record: props.record
        }
    }

    onSave = () => {
        const { record } = this.state
  
        const request = {
            endPoint: this.props.apiUrl + '/badge/' + record.uid,
            method: 'PATCH',
            token: this.props.JWTToken,
            params: {
                uid: record.uid,
                costcenter:record.costcenter,
                titulaire:record.titulaire
            }
        }

        fetchServer(request,
             () => {this.props.onClose()},
            ()=>{})

    }

    onPropertyChanged = (e) => {
        const { record } = this.state


        record[e.target.name] = e.target.value
        
        this.setState({ record: { ...record } })
    }

    render() {
        const { record } = this.state
        const libelleTitulaire = 'Titulaire'
        const libelleCostCenter = 'Centre de Cout'


        return (
            <Container className="editorFunction">
                <Form>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Type Badge
                        </Form.Label>
                        <Col sm="8">
                            <Form.Label >
                                {record.typebadge.libelle}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItemv">
                        <Form.Label column sm="4">
                            Badge
                        </Form.Label>
                        <Col sm="8">
                            <Form.Label >
                                {record.badge}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Statut
                        </Form.Label>
                        <Col sm="8">
                            <Form.Label >
                                {record.status.libelle}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            {libelleTitulaire}
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.titulaire} name="titulaire" onChange={record.fournisseur.code==='EUROTOLL'?null:(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            {libelleCostCenter}
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.costcenter} name="costcenter" onChange={ (e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                </Form>








                <Row className="FormButtonBar">
                    <Col style={{ textAlign: 'center' }}>
                        <Button className='formCancel' onClick={() => this.props.onClose()} style={{ color: 'white', backgroundColor: '#24b5b9' }}>Annuler</Button>
                    </Col>
                    <Col style={{ textAlign: 'center' }}>
                        <Button className='formSubmit' onClick={this.onSave} style={{ color: 'white', backgroundColor: '#24b5b9' }}>Enregistrer</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

BadgeEditor.propTypes = {
    dispatch: PropTypes.func,
    apiUrl: PropTypes.string,
    record: PropTypes.object,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    onClose: PropTypes.func
};

export default connect(mapStateToProps)(BadgeEditor);
